import { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import { getSignedInUser } from '../../services/authService';
import Header from './header';
import Nav from './nav';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;
const NAV_WIDTH = 280;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div', {
  shouldForwardProp: (prop) => prop !== 'navCollapsed',
})(({ theme, navCollapsed }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    transition: theme.transitions.create('margin-left', { duration: theme.transitions.duration.shorter }),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const [navCollapsed, setNavCollapsed] = useState(false);
  const [pageTitle, setPageTitle] = useState('');

  // Safely get user from localStorage (may be null if not logged in or invalid)
  let authedUser = null;
  try {
    authedUser = getSignedInUser();
  } catch {
    // localStorage might have invalid JSON, treat as not authenticated
    authedUser = null;
  }

  if (!authedUser) {
    return <Navigate to="/login" replace />;
  }

  return (
    <StyledRoot>
      <Header onOpenNav={() => setOpen(true)} navCollapsed={navCollapsed} onToggleNav={() => setNavCollapsed((prev) => !prev)} pageTitle={pageTitle} />
      {authedUser ? <Nav openNav={open} onCloseNav={() => setOpen(false)} account={authedUser} collapsed={navCollapsed} onToggleNav={() => setNavCollapsed((prev) => !prev)} /> : null}
      <Main navCollapsed={navCollapsed}>
        <Outlet context={{ setPageTitle }} />
      </Main>
    </StyledRoot>
  );
}
